import React from 'react'
import CSSModules from 'helpers/CSSModulesUtil'
import styles from './styles.scss'
import { Flex } from 'reflexbox'
import { IconButton } from 'react-toolbox/lib/button'

const getIcon = (icon) => {
  if(icon){
    return (
      <IconButton styleName='button' icon={icon} theme={styles}/>
    )
  }
  return
}

const Tag = (props) => {

  const tagStyle = {
    backgroundColor: props.color
  }

  const className = props.className + ' ' + (props.large ? styles.large : '')

  return (
    <Flex styleName='tag' className={className} style={tagStyle}>
      { getIcon(props.icon) }
      { props.text }
    </Flex>
  )
}

export default CSSModules(styles)(Tag)